import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';
import { ADMIN_NAV_ITEMS } from '../../../constants/adminNav';

function resolveAdminCrumbs(pathname, t) {
  const crumbs = [{ path: '/admin', label: t('admin.nav.dashboard') }];
  const exact = ADMIN_NAV_ITEMS.find((item) => item.path === pathname && !item.reserved);
  if (exact && exact.path !== '/admin') {
    crumbs.push({ path: exact.path, label: t(exact.labelKey) });
    return crumbs;
  }
  const userMatch = pathname.match(/^\/admin\/users\/([^/]+)$/);
  if (userMatch) {
    const users = ADMIN_NAV_ITEMS.find((item) => item.id === 'users' && !item.reserved);
    if (users) {
      crumbs.push({ path: users.path, label: t(users.labelKey) });
      crumbs.push({ path: pathname, label: t('admin.users.detail.crumb') });
    }
  }
  return crumbs;
}

export default function AdminBreadcrumbs() {
  const { t } = useLanguage();
  const location = useLocation();
  const crumbs = resolveAdminCrumbs(location.pathname, t);
  return (
    <nav className="flex flex-wrap items-center gap-1 px-4 pt-3 text-xs text-slate-500">
      {crumbs.map((c, i) => (
        <React.Fragment key={c.path}>
          {i > 0 ? <span>/</span> : null}
          {i === crumbs.length - 1 ? (
            <span className="font-medium text-slate-700">{c.label}</span>
          ) : (
            <Link to={c.path} className="hover:text-indigo-600">
              {c.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
